import { useEffect, useState } from "react";
import { api, formatPrice, MEDIA, MENU_CATEGORIES } from "../lib/api";

export default function Menu() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(MENU_CATEGORIES[0].key);

  useEffect(() => {
    api.get("/menu")
      .then((r) => {
        if (Array.isArray(r?.data)) {
          setItems(r.data);
        } else {
          setItems([]);
        }
      })
      .catch((err) => {
        console.log("Menu API error:", err);
        setItems([]);
      });
  }, []);

  const grouped = MENU_CATEGORIES.map((c) => ({
    ...c,
    items: Array.isArray(items)
      ? items.filter((i) => i.category === c.key)
      : [],
  }));

  return (
    <div data-testid="menu-page" className="pt-32">
      <section className="relative h-[40vh] min-h-[320px] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={MEDIA.dish}
            alt="Menu"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0F120E]/60 to-[#0F120E]" />
        </div>

        <div className="relative max-w-[1400px] mx-auto w-full px-6 md:px-12 pb-12 z-10">
          <div className="overline mb-4">
            North Indian · Italian · Asian · Continental
          </div>

          <h1 className="font-display text-5xl sm:text-7xl text-[#F9F6F0]">
            The Menu
          </h1>
        </div>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 md:px-12 py-16">
        <div className="flex flex-wrap gap-2 md:gap-3 mb-16 sticky top-20 bg-[#0F120E]/85 backdrop-blur-xl py-4 -mx-6 px-6 z-20 border-b border-[#2E3628]">
          {MENU_CATEGORIES.map((c) => (
            <button
              key={c.key}
              data-testid={`menu-tab-${c.key}`}
              onClick={() => {
                setActive(c.key);

                document
                  .getElementById(`cat-${c.key}`)
                  ?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
              }}
              className={`px-4 py-2 text-[11px] uppercase tracking-[0.2em] border transition-colors ${
                active === c.key
                  ? "border-[#D4C1A0] text-[#D4C1A0]"
                  : "border-[#2E3628] text-[#9AA894] hover:text-[#F9F6F0]"
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>

        {grouped.map((group) => (
          <div
            key={group.key}
            id={`cat-${group.key}`}
            className="mb-24 scroll-mt-32"
          >
            <div className="overline mb-6">{group.label}</div>

            <div
              className="space-y-1"
              data-testid={`category-${group.key}`}
            >
              {group.items.length === 0 && (
                <p className="text-[#9AA894] text-sm py-4">
                  More to be revealed soon.
                </p>
              )}

              {group.items.map((item) => (
                <div
                  key={item.id}
                  data-testid={`menu-item-${item.id}`}
                  className="flex items-baseline py-6 border-b border-[#2E3628]/60"
                >
                  <div className="flex-1">
                    <h3 className="font-display text-2xl text-[#F9F6F0]">
                      {item.name}
                    </h3>

                    <p className="text-[#9AA894] text-sm mt-2 max-w-2xl leading-relaxed">
                      {item.description}
                    </p>
                  </div>

                  <div className="menu-dots hidden md:block" />

                  <div className="font-display text-xl text-[#D4C1A0] ml-4 whitespace-nowrap">
                    {formatPrice(item.price)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
              }
